<template>
  <div class="today-evaluation-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-center">
        <div class="logo-section">
          <div class="platform-title">{{ companyName }}·电子招投标交易平台</div>
        </div>
      </div>
    </div>
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 页面标题 -->
      <div class="content-title">
        <h1>今日开标</h1>
      </div>
      <!-- 筛选标签区域 -->
      <div class="filter-tabs">
        <div class="tab-item" :class="{ active: activeTab === 'all' }" @click="setActiveTab('all')">
          全部
        </div>
        <div v-for="city in cityTabs" :key="city" class="tab-item" :class="{ active: activeTab === city }"
          @click="setActiveTab(city)">
          {{ city }}
        </div>
      </div>
      <!-- 项目列表表格 -->
      <div class="table-container">
        <el-table :data="filteredProjects" border style="width: 100%"
          :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
          :cell-style="{ color: '#303133' }" class="project-table">
          <el-table-column prop="projectName" label="项目名称">
            <template slot-scope="scope">
              <div class="project-name-cell">
                <span class="project-name">{{ scope.row.projectName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="bidSectionCode" label="标段编码"></el-table-column>
          <el-table-column prop="bidSectionName" label="标段名称"></el-table-column>
          <el-table-column prop="bidEvaluationRoom" label="评标室">
            <template slot-scope="scope">
              <div class="evaluation-room-cell">
                <span class="room-text">{{ scope.row.bidEvaluationRoom }}</span>
                <div class="action-icon" @click="handleEnterEvaluationRoom(scope.row)">
                  <img src="@/assets/image/jinru.png" style="width: 30px; height: 30px;cursor: pointer;" />
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import {
  getEvaluationRoomList
} from '@/api/evaluation/api'
export default {
  name: 'TodayEvaluation',
  data() {
    return {
      activeTab: 'all',
      selectedProject: null,
      projects: [], // 从接口获取的项目数据
      cityTabs: [] // 动态生成的城市标签
    }
  },
  computed: {
    companyName() {
      return this.$channelMaterial.getCompanyName()
    },
     channelCode() {
            return this.$channelMaterial.getChannelCode()
        },
    filteredProjects() {
      if (this.activeTab === 'all') {
        return this.projects
      } else {
        return this.projects.filter(project => project.projectLocationCity === this.activeTab)
      }
    }
  },
  mounted() {
    this.initPage();

       
  },
  methods: {
    // 初始化页面信息
    initPage() {
      this.loadEvaluationRoomList();
    },
    // 加载评标室列表
    async loadEvaluationRoomList() {
      try {
        const response = await getEvaluationRoomList({
               channelCode:this.channelCode
        });
        if (response.code === 200 ) {
          this.projects = response.data.map((item, index) => ({
            id: item.committeeId || index + 1,
            projectName: item.projectName,
            bidSectionCode: item.bidSectionCode,
            bidSectionName: item.bidSectionName,
            bidEvaluationRoom: item.bidEvaluationRoom,
            projectLocationCity: item.projectLocationCity,
            projectCode: item.projectCode,
            projectId: item.projectId,
            committeeId: item.committeeId
          }));
          this.generateCityTabs();
        } else {
          this.$message.error(response.msg || '获取评标室列表失败');
        }
      } catch (error) {
        console.error('获取评标室列表失败:', error);
        this.$message.error('获取评标室列表失败');
      }
    },
    // 动态生成城市标签
    generateCityTabs() {
      const cities = [...new Set(this.projects.map(project => project.projectLocationCity).filter(city => city))];
      this.cityTabs = cities.sort();
    },
    // 进入评标室
    handleEnterEvaluationRoom(row) {
      Cookies.remove('bidSectionCode')
      Cookies.remove('committeeId')
      Cookies.remove('projectId')
      Cookies.remove('projectCode')
      Cookies.remove('projectName')
      Cookies.remove('committeeId')
      Cookies.set('bidSectionCode', row.bidSectionCode)
      Cookies.set('committeeId', row.committeeId)
      Cookies.set('projectId', row.projectId)
      Cookies.set('projectCode', row.projectCode)
      Cookies.set('projectName', row.projectName)
      Cookies.set('committeeId', row.committeeId)
      window.open('expertLogin', '_blank')
         Cookies.remove('token')
    },
    // 设置激活的标签
    setActiveTab(tab) {
      this.activeTab = tab
    },
  }
}
</script>

<style lang="less" scoped>
.today-evaluation-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f0f4fb;

  .page-header {
    background: #409EFF;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .platform-title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .main-content {
    margin: 30px 200px;
    padding: 20px;
    border-radius: 10px;
    background-color: white;

    .content-title {
      text-align: center;
      margin-bottom: 30px;

      h1 {
        font-size: 28px;
        font-weight: bold;
        color: #333;
        margin: 0;
      }
    }

    .filter-tabs {
      display: flex;
      gap: 0;
      margin-bottom: 20px;

      .tab-item {
        padding: 12px 24px;
        background-color: #e4e7ed;
        color: #606266;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        border-right: none;
        font-size: 14px;
        transition: all 0.3s ease;

        &:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }

        &:last-child {
          border-right: 1px solid #dcdfe6;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }

        &.active {
          background-color: #409EFF;
          color: white;
          border-color: #409EFF;
        }

        &:hover:not(.active) {
          background-color: #f5f7fa;
        }
      }
    }

    .table-container {
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      overflow: hidden;

      .project-table {
        .project-name-cell {
          display: flex;
          align-items: center;
          gap: 12px;

          .project-name {
            flex: 1;
            line-height: 1.5;
          }
        }

        .evaluation-room-cell {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .room-text {
            flex: 1;
          }

          .action-icon {
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>
